export default __webpack_public_path__ + "static/media/info_cashout.min.f94460a6.png";